export default __webpack_public_path__ + "static/media/categ_counter.13c7a833.svg";